import { create } from 'zustand'

// Claves/Helpers para persistencia web segura
const LS_KEY = 'interactions_cache_v1'
const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

function loadFromStorage(): { [postId: string]: any } {
    if (!isBrowser) return {}
    try {
        const raw = window.localStorage.getItem(LS_KEY)
        if (!raw) return {}
        const parsed = JSON.parse(raw)
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed
        return {}
    } catch {
        return {}
    }
}

function saveToStorage(state: { [postId: string]: any }) {
    if (!isBrowser) return
    try {
        // Limitar tamaño básico: sólo guardar campos clave por post
        const compact: Record<string, any> = {}
        for (const [k, v] of Object.entries(state || {})) {
            const key = String(k)
            const it = v || {}
            compact[key] = {
                post_id: String(it.post_id ?? key),
                reactions: Array.isArray(it.reactions) ? it.reactions : [],
                latest_reactions: Array.isArray(it.latest_reactions) ? it.latest_reactions : [],
                user_reaction: Array.isArray(it.user_reaction) ? it.user_reaction : [],
                comment_count: typeof it.comment_count === 'number' ? it.comment_count : 0,
                comment_first: it.comment_first || {},
                views: typeof it.views === 'number' ? it.views : 0,
            }
        }
        window.localStorage.setItem(LS_KEY, JSON.stringify(compact))
    } catch {}
}

interface InteractionState {
    interactions: { [postId: string]: any } // Adjust type as needed
    setInteractions: (newInteractions: { [postId: string]: any }) => void
    getInteraction: (postId: string) => (state: InteractionState) => any
}

export const useInteractionsStore = create<InteractionState>((set) => ({
    // Hidratar desde localStorage en web para modo offline-first
    interactions: loadFromStorage(), // { [postId]: interaction }
    setInteractions: (newInteractions) =>
        set((state) => {
            const next = { ...state.interactions, ...newInteractions }
            // Persistencia web (no afecta mobile)
            saveToStorage(next)
            return { interactions: next }
        }),
    getInteraction: (postId) => (state) => state.interactions[postId],
}))